import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProviderWrapper } from "./context/AuthContext";
import { DriverProvider } from "./context/DriverContext";
import { GlobalSettingsProvider } from "./context/GlobalSettingsContext";
import "./index.css";
import "antd/dist/reset.css";
import App from "./App";
import "./i18n";
import { startVersionGuard } from "./versionGuard";

startVersionGuard();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <AuthProviderWrapper>
      <GlobalSettingsProvider>
        <DriverProvider>
          <App />
        </DriverProvider>
      </GlobalSettingsProvider>
    </AuthProviderWrapper>
  </Router>,
);
